import { ReducerBuilder } from './reducerBuilder';
import { IntlState, LanguageState } from 'acscp/store';
import { ChangeLocaleAutomatically, ChangeLocaleFromSharingLink, ChangeLocaleFromUserDetails, ChangeLocaleManually } from 'acscp/actions';

export const intlReducer =
    new ReducerBuilder<IntlState>({
        locale: 'en-GB',
        languageState: LanguageState.Uninitialised
    })
    .actionCase(ChangeLocaleFromUserDetails, (state, action) => {
        return {
            locale: action.locale,
            languageState: LanguageState.SetByUserDetails,
        };
    })
    .actionCase(ChangeLocaleManually, (state, action) => {
        return {
            locale: action.locale,
            languageState: LanguageState.SetManually,
        };
    })
    .actionCase(ChangeLocaleAutomatically, (state, action) => {
        return {
            locale: action.locale,
            languageState: LanguageState.SetByBrowser,
        };
    })
    .actionCase(ChangeLocaleFromSharingLink, (state, action) => {
        return {
            locale: action.locale,
            languageState: LanguageState.SetBySharingLink,
        };
    })
    .build();
